module.exports = __webpack_public_path__ + "static/ic-workspace-6547855cfd4bbcbe0128b40ad6649b58.svg";